import React from "react";
import './../styles/default.css';
import NavbarTop from './default/Navbartop';
import Banner from './default/Banner';
import Footer from './default/Footer';

const PoliticaCookies = () => {
    return (
        <>
            <div className="app-default app-container">
                <NavbarTop />
                <div className="main-content page-terminos-condiciones">
                    <div className="page-container">
                        <Banner src="/imagenes/terminos-y-condiciones/banner1.webp" type="imagen" overlay="gradient">
                            <h1 className="text-white">Política de Cookies</h1>
                        </Banner>

                        <div className="container-section section flex-column gap-40">
                            <div className="flex-column gap-10">
                                <h3>¿Qué son las cookies?</h3>
                                <p>Las cookies son pequeños archivos que se almacenan en tu dispositivo cuando visitas nuestro sitio web. Nos ayudan a mejorar tu experiencia como usuario.</p>
                            </div>

                            <div className="flex-column gap-10">
                                <h3>¿Qué cookies usamos?</h3>
                                <ul>
                                    <li><b>Cookies funcionales: </b>necesarias para el funcionamiento básico del sitio.</li>
                                    <li><b>Cookies analíticas (futuro): </b>nos ayudan a entender cómo interactúan los usuarios con la plataforma para mejorarla. </li>
                                    <li><b>Cookies de terceros (futuro): </b>como Google Analytics o Meta Pixel, que podrían recopilar información anónima para fines estadísticos o publicitarios. </li>
                                </ul>
                                <p>Actualmente, el uso de cookies es mínimo, pero <b>en el futuro podríamos implementar herramientas que requieran consentimiento explícito del usuario.</b></p>
                            </div>
                            
                            <div className="flex-column gap-10">
                                <h3>¿Cómo se pueden desactivar?</h3>
                                <p>Puedes configurar tu navegador para bloquear o eliminar cookies, aunque esto podría afectar el funcionamiento de ciertas funciones de la plataforma.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
};

export default PoliticaCookies;